export enum userType {
  Admin = 'Admin',
  User = 'User'
}

export class UserTypeEnum {
  static getEnumType(role: number): string {
    switch (role) {
      case 1:
        return userType.Admin;
      case 2:
        return userType.User;
      default:
        return 'nil';
    }
  }
}
